import user from './entity/userRequests';
import organization from './entity/organizationRequests';
import organizationRelationship from './entity/organizationRelationshipRequests';
import fundingOpportunity from './entity/fundingOpportunityRequests';
import fundingOpportunityDraft from './entity/fundingOpportunityDraftRequests';
import program from './entity/programRequests';
import ref from './entity/refRequests';
import rules from './entity/rulesRequests';
import workflow from './entity/workflowRequests';
import dynamicData from './entity/dynamicDataRequests';
import config from './entity/configRequests';
import community from './entity/communityRequests';
import snapshot from './entity/snapshotRequests';
import history from './entity/historyRequests';
import location from './entity/locationRequests';
import template from './entity/templateRequests';
import search from './entity/searchRequests';
import auth from './entity/authRequests';
import registration from './entity/registrationRequests';
import attachment from './entity/attachmentRequests';
import panelreview from './entity/panelreviewRequests';
import panelReviewV2 from './entity/panelReviewV2Requests';
import report from './entity/reportRequests';
import tracker from './entity/trackerRequests';
import vendor from './entity/vendorRequests';
import disasterArea from './entity/disasterAreaRequests';
import disaster from './entity/disasterRequests';
import handler from './handlers.js';
import admin from './entity/adminRequests';
import camunda from './entity/camundaRequests';
import prescore from './entity/prescoreRequests';
import commitment from './entity/commitmentRequests';
import allocation from './entity/allocationRequests';
import obligation from './entity/obligationRequests';
import ehp from './entity/ehpRequests';

export default {
  user,
  organization,
  organizationRelationship,
  fundingOpportunity,
  fundingOpportunityDraft,
  program,
  ref,
  rules,
  workflow,
  dynamicData,
  config,
  community,
  snapshot,
  history,
  location,
  search,
  template,
  handler,
  auth,
  ehp,
  registration,
  attachment,
  panelreview,
  panelReviewV2,
  report,
  tracker,
  vendor,
  disasterArea,
  disaster,
  admin,
  camunda,
  prescore,
  commitment,
  allocation,
  obligation,
};
